<template lang="pug">
#laudos
    ModalOpcoes(
        @update:lista='requestLaudos',
        @showModalOpcoes='changeShowModalOpcoes'
    )
</template>

<script>
import TipoLaudo from '@/constants/TipoLaudo';
import ModalOpcoes from '@/components/laudos/croqui/ModalOpcoes.vue';

import LaudoService from '@/services/LaudosService';
import { mapState } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'Laudos',
    components: {
        ModalOpcoes
    },
    computed: {
        ...mapState(['usuarioLogado', 'usuarioIsLaudo'])
    },

    data() {
        return {
            showModalVisualizacao: false,
            showModalOpcoes: false,
            idLaudo: null,
            laudos: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                empresasIds: [],
                tipoLaudoId: TipoLaudo.CROQUI
            },
            showModalInsercaoResultados: false,
            showModalArquivoVetorial: false,
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false
        };
    },
    async created() {
        if (this.usuarioIsLaudo) {
            this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
        }
        await this.getLaudos();
    },
    async mounted() {
        await connect();

        if (this.usuarioLogado) {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/croqui/resultado`,
                response => {
                    const laudoProcessado = JSON.parse(response);
                    const laudoSelecionado = this.laudos.find(
                        p => p.id === laudoProcessado.id
                    );
                    if (laudoSelecionado) {
                        laudoSelecionado.situacao.codigo =
                            laudoProcessado.situacao.codigo;
                        laudoSelecionado.situacao.nome =
                            laudoProcessado.situacao.nome;
                        laudoSelecionado.dataFinalizacaoFormatado =
                            laudoProcessado.dataFinalizacaoFormatado;
                    }
                }
            );
        } else {
            this.$notify.error({
                message: this.$t('mensagens.laudos.erro.usuarioDeslogado')
            });
        }
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalOpcoes() {
            this.showModalOpcoes = !this.showModalOpcoes;
            this.$emit('showModalOpcoes');
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(id => {
                idsTerritorio += id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoCroqui',
                params: { idsTerritorio }
            });
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.naoFoiPossivelCarregarOsDados')
                });
            } finally {
                this.loading = false;
            }
        },

        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },

        handleModalVetorial(rowInfo) {
            this.showModalArquivoVetorial = !this.showModalArquivoVetorial;
            this.rowInfo = rowInfo;
        },

        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.requestLaudos();
        },

        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.requestLaudos();
        },

        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
